// extracted by mini-css-extract-plugin
module.exports = {"container":"participant_container__2UxeK","containerLeft":"participant_containerLeft__2W_fU"};